import { useEffect, useState } from "react";
import { db } from "../firebase/config";
import { doc, setDoc, onSnapshot } from "firebase/firestore";
import { useAuth } from "./useAuth";


export const useAdmin = () => {
  const { user } = useAuth();
  const [, setIsCancelled] = useState(false);
  const [myAdminRecord, setMyAdminRecord] = useState(null);
  const [, setError] = useState(null);
  const [, setMydocPending] = useState(false);

  // const dispatchIfNotCancelled = (action) => {
  //   if (!isCancelled) {
  //     dispatch(action);
  //     setMydocPending(true);
  //   }
  // };

  //fires once and whenever the collection changes
  useEffect(() => {
    setMydocPending(true);
    //set up a real time listener to a firestore collection
    let ref = doc(db, "user_admin", user && user.uid ? user.uid : "empty");
    const unsubscribe = onSnapshot(
      ref,
      (snapshot) => {
        if (snapshot.exists()) {
          setMyAdminRecord(snapshot.data());
        } else {
          if (user && user.uid) {
            setDoc(
              doc(db, "user_admin", user.uid),
              { admin: false },
              { merge: true }
            );
          }
          setMyAdminRecord(null);
        }
        setMydocPending(false);
        setError(null);
      },
      (error) => {
        console.log(error);
        setMydocPending(false);
        setError("could not fetch the doc");
      }
    );
    //unsub on unmount
    return () => unsubscribe();
  }, [user]);

  useEffect(() => {
    return () => setIsCancelled(true);
  }, [myAdminRecord]);

  const updateAdminRecord = (param) => {
    setDoc(doc(db, "user_admin", user.uid), { [param]: true }, { merge: true });
  };

  return { myAdminRecord, updateAdminRecord };
};
